module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-002sp-1079.bcc37288.jpg";